import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import DialogActions from "@material-ui/core/DialogActions";
import StepOne from "./steps/StepOne";
import StepTwo from "./steps/StepTwo";
import StepThree from "./steps/StepThree";
import StepFour from "./steps/StepFour";
import StepFive from "./steps/StepFive";
import StepSix from "./steps/StepSix";
import Close from "@material-ui/icons/Close";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/styles";
import AutomService from "../../../../services/AutomService/AutomService";
import BotService from "../../../../services/BotService/BotService";
import LibraryService from "../../../../services/LibraryService/LibraryService";
import StepSelectLocalLibrary from "./steps/StepSelectLocalLibrary";
import StepSelectLocalAction from "./steps/StepSelectLocalAction";
import StepVariables from "./steps/StepVariables";
import StepUploadJson from "./steps/StepUploadJson";

import StepSelectPublishType from "./steps/StepSelectPublishType";

import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../recoil-store/recoil-state';
import "./steps/Steps.css";

const Publish = (props) => {
    const { t } = useTranslation();
    const setAlert = useSetRecoilState(alertState);

    const [isRequired, setIsRequired] = useState(true);
    const [publishDetail, setPublishDetail] = useState();
    const [activeStep, setActiveStep] = useState(0);
    const [stepCount, setStepCount] = useState();
    const [variables, setVariables] = useState([]);
    const [appConfigFile, setAppConfigFile] = useState();
    const [hasApplicationJson, setHasApplicationJson] = useState(false);

    useEffect(() => {
        let data = { publish_detail: {} };
        if (props.automDetail.type === 'Autom') {
            data.publish_detail = {
                name: "",
                tags: "",
                automation_types_id: "",
                security_stage_id: "",
                description: "",
                short_description: "",
                benefit: "",
                support: "",
                configuration: "",
                guide: "",
                applications: [],
                business_process_id: [],
                categories: [],
                images: [],
                type: "bot",
                publish_type: 'new',
                latest_version: '1.0.0'
            }
            setStepCount(7);

            const copyVariables = JSON.parse(JSON.stringify(props.variables));
            setVariables(copyVariables);
        } else if (props.automDetail.type === 'Library') {
            data.publish_detail = {
                name: "",
                tags: props.libraryDetail.library?.tags || "",
                automation_types_id: "",
                description: props.libraryDetail.library.bot_details?.description || "",
                short_description: props.libraryDetail.library.bot_details?.short_description || "",
                benefit: props.libraryDetail.library.bot_details?.benefit || "",
                support: props.libraryDetail.library.bot_details?.support || "",
                configuration: props.libraryDetail.library.bot_details?.configuration || "",
                guide: props.libraryDetail.library.bot_details?.guide || "",
                //application_id: props.automDetail.library.application_id,
                categories: props.libraryDetail.library.categories || [],
                business_processes: props.libraryDetail.library.business_processes,
                images: [],
                type: "library",
                environment_target: {
                    global: {
                        status: false,
                        publish_type: "new",
                    }
                }
            }
            setStepCount(5);
        } else {
            data.publish_detail = {
                name: "",
                short_description: "",
                configuration: "",
                type: "action",
                status: '',
                library: {}
            }
            setHasApplicationJson(false);
            setStepCount(6);
            const copyVariables = JSON.parse(JSON.stringify(props.variables));
            setVariables(copyVariables);
        }
        setPublishDetail(data);
    }, [])

    const handleClose = () => {
        props.setOpenPublish(false);
    };

    const BorderLinearProgress = withStyles((theme) => ({
        root: {
            height: 15,
            borderRadius: 15,
        },
        colorPrimary: {
            backgroundColor: "#fff",
            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
        },
        bar: {
            borderRadius: 15,
            backgroundColor: "#5AC384",
        },
    }))(LinearProgress);

    const handleNext = async () => {
        if (activeStep === 1 && props.automDetail.type === 'Autom' && publishDetail.publish_detail.publish_type === "new") {
            const response = await BotService.checkBotName(publishDetail.publish_detail.name);
            if (!response.status) {
                setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.PUBLISH.' + response.message), severity: 'error' }))
                return;
            }
        }
        setActiveStep(activeStep + 1);
        if (!isRequired) {
            setIsRequired(true);
        }
    };

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    const checkAndSetVariables = (v) => {
        v.sort((a, b) => (a.order > b.order) ? 1 : -1)
        let copyVariables = Array.from(variables);

        let order = 1;

        for (let item of v) {
            const i = copyVariables.findIndex(x => x.name === item.name);
            if (i !== -1) {
                copyVariables[i].order = order;
                copyVariables[i].is_required = item.is_required;
                copyVariables[i].secret = item.secret;
                order++;
            }
        }
        setVariables(copyVariables);
    }

    const actionPublishSteps = () => {
        switch (activeStep) {
            case 0:
                return (
                    <StepSelectLocalLibrary
                        publishDetail={publishDetail}
                        setIsRequired={setIsRequired}
                        setPublishDetail={setPublishDetail}
                    />
                );
            case 1:
                return (
                    <StepSelectLocalAction
                        publishDetail={publishDetail}
                        setIsRequired={setIsRequired}
                        setPublishDetail={setPublishDetail}
                        checkAndSetVariables={checkAndSetVariables}
                        setHasApplicationJson={setHasApplicationJson}
                    />
                );
            case 2:
                return (
                    <StepOne
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            case 3:
                return (
                    <StepFive
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            case 4:
                return (
                    <StepVariables
                        variables={variables}
                        setVariables={setVariables}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            case 5:
                return (
                    <StepUploadJson appConfigFile={appConfigFile} setAppConfigFile={setAppConfigFile}
                        has_application_json={hasApplicationJson} setIsRequired={setIsRequired} />
                );
            default:
                break;
        }
    }

    const libraryPublishSteps = () => {
        switch (activeStep) {
            case 0:
                return (
                    <StepOne
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                        libraryDetail={props.libraryDetail}
                    />
                );
            case 1:
                return (
                    <StepTwo
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            case 2:
                return (
                    <StepThree
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            case 3:
                return (
                    <StepFive
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            case 4:
                return (
                    <StepSix
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            default:
                break;
        }
    }

    const botPublishSteps = () => {
        switch (activeStep) {
            case 0:
                return (
                    <StepSelectPublishType
                        publishDetail={publishDetail}
                        setIsRequired={setIsRequired}
                        setPublishDetail={setPublishDetail}
                        checkAndSetVariables={checkAndSetVariables}
                    />
                );
            case 1:
                return (
                    <StepOne
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            case 2:
                return (
                    <StepTwo
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            case 3:
                return (
                    <StepThree
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            case 4:
                return (
                    <StepFour
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            case 5:
                return (
                    <StepFive
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            case 6:
                return (
                    <StepSix
                        setPublishDetail={setPublishDetail}
                        publishDetail={publishDetail}
                        isRequired={isRequired}
                        setIsRequired={setIsRequired}
                    />
                );
            default:
                break;
        }
    }

    const createBotPublishObject = () => {
        let newObject = JSON.parse(JSON.stringify(publishDetail));

        newObject.publish_detail.short_description =
            publishDetail.publish_detail.short_description.toString("html");
        newObject.publish_detail.description =
            publishDetail.publish_detail.description.toString("html");
        newObject.publish_detail.guide =
            publishDetail.publish_detail.guide.toString("html");
        newObject.publish_detail.configuration =
            publishDetail.publish_detail.configuration.toString("html");
        newObject.publish_detail.benefit =
            publishDetail.publish_detail.benefit.toString("html");

        newObject = {
            autom_version_id: props.automDetail.versionId,
            flow_details: {
                variables: [],
                integration_type: props.automDetail?.integration_type, // standart,schedule,trigger
                trigger_type: props.automDetail.trigger_type,
                trigger_mode_id: props.automDetail.trigger_mode_id,
                is_private: true,
                flow: props.flow
            },
            ...newObject,
        };
        return newObject;
    }

    const createActionPublishObject = () => {
        let newObject = JSON.parse(JSON.stringify(publishDetail));

        newObject.publish_detail.short_description =
            publishDetail.publish_detail.short_description.toString("html");
        newObject.publish_detail.configuration =
            publishDetail.publish_detail.configuration.toString("html");
        let formData = new FormData();
        formData.append('file', appConfigFile);
        formData.append('flow_details', JSON.stringify({
            variables: variables,
            flow: props.flow
        }));
        formData.append('publish_detail', JSON.stringify(newObject.publish_detail));

        return formData;
        // return {
        //     flow_details: {
        //         variables: variables,
        //         flow: props.flow
        //     },
        //     ...newObject,
        // };
    }

    const createLibraryPublishObject = () => {
        let newObject = JSON.parse(JSON.stringify(publishDetail));

        newObject.publish_detail.short_description =
            publishDetail.publish_detail.short_description.toString("html");
        newObject.publish_detail.description =
            publishDetail.publish_detail.description.toString("html");
        newObject.publish_detail.guide =
            publishDetail.publish_detail.guide.toString("html");
        newObject.publish_detail.configuration =
            publishDetail.publish_detail.configuration.toString("html");
        newObject.publish_detail.benefit =
            publishDetail.publish_detail.benefit.toString("html");

        return {
            library_details: props.automDetail.library,
            ...newObject,
            triggers: props.triggers
        };
        // return {
        //     flow_details: {
        //         variables: props.variables,
        //         flow: props.flow
        //     },
        //     ...newObject,
        // };
    }

    const handlePublish = async () => {
        setIsRequired(true);
        if (publishDetail.publish_detail.type === 'bot') {
            const response = await AutomService.postPublish(createBotPublishObject());
            if (response?.status) {
                handleClose();
                localStorage.removeItem("automType");
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('CONTENT.PUBLISH.SUCCESSFULLY'),
                    severity: 'success'
                }))
            } else {
                setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.PUBLISH.' + response.message), severity: 'error' }))
            }
        } else if (publishDetail.publish_detail.type === 'library') {
            const response = await LibraryService.publishCustomLibrary(createLibraryPublishObject());
            if (response?.status) {
                handleClose();
                // render library version list in library detail page
                props.reRender();
                localStorage.removeItem("automType");
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.PUBLISH.' + response.message),
                    severity: 'success'
                }))
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.PUBLISH.' + response.message),
                    severity: 'error'
                }))
            }
        } else {
            const response = await LibraryService.publishCustomAction(createActionPublishObject());
            if (response?.status) {
                handleClose();
                localStorage.removeItem("automType");
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.PUBLISH.' + response.message),
                    severity: 'success'
                }))
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.PUBLISH.' + response.message),
                    severity: 'error'
                }))
            }
        }
        setTimeout(() => {
            setIsRequired(false);
        }, 500)
    };

    return (
        <Dialog
            id="publish-dialog"
            data-test="autom-add-new"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    padding: "32px 48px",
                    overflowX: "hidden",
                    width: '100%'
                },
            }}
        >
            <DialogTitle style={{ padding: "0 0 20px 0" }} id="alert-dialog-title">
                <div id="about-title">
                    {t("CONTENT.FLOW.PUBLISH")}
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>

            <>
                <span className="process-info">
                    {Math.round((activeStep / stepCount) * 100)} %{" "}
                    {t("CONTENT.PUBLISH.COMPLETED")}
                </span>
                <BorderLinearProgress
                    variant="determinate"
                    value={Math.round((activeStep / stepCount) * 100)}
                />
            </>

            <DialogActions
                style={{
                    justifyContent: "space-between",
                    padding: "0"
                }}
            >
                {
                    props.automDetail.type === 'Autom' ? botPublishSteps() :
                        props.automDetail.type === 'Library' ? props.automDetail.type === 'Library' && libraryPublishSteps()
                            : props.automDetail.type === 'Action' && actionPublishSteps()
                }
            </DialogActions>
            <div className="process-buttons-row">
                <Button
                    onClick={handleBack}
                    variant="outlined"
                    disabled={activeStep === 0}
                    style={{
                        backgroundColor: activeStep === 0 ? "#DBDBDB" : "#46474E",
                        borderRadius: "2px",
                        color: "#fff",
                        width: "20%",
                        border: "none",
                        fontWeight: 700,
                    }}
                >
                    {t("CONTENT.PUBLISH.BACK")}
                </Button>
                {(activeStep !== stepCount - 1) ? (
                    <Button
                        onClick={handleNext}
                        variant="outlined"
                        disabled={isRequired}
                        style={{
                            backgroundColor:
                                isRequired
                                    ? "#DBDBDB"
                                    : "#46474E",
                            borderRadius: "2px",
                            color: "#fff",
                            width: "20%",
                            border: "none",
                            fontWeight: 700,
                        }}
                    >
                        {t("CONTENT.PUBLISH.NEXT")}
                    </Button>
                ) : (
                    <Button
                        onClick={handlePublish}
                        variant="outlined"
                        disabled={isRequired}
                        style={{
                            backgroundColor: isRequired ? "#DBDBDB" : "#46474E",
                            borderRadius: "2px",
                            color: "#fff",
                            width: "20%",
                            border: "none",
                            fontWeight: 700,
                        }}
                    >
                        {t("CONTENT.FLOW.PUBLISH")}
                    </Button>
                )}
            </div>
        </Dialog>
    );
};

export default Publish;
